const hasUrlInList = (list) => list.filter((val) => val && val.url).length >= 1;
export default hasUrlInList;
